import dayjs from "dayjs";
import ManagementTable from "src/components/pages/Management/ManagementTable/ManagementTable";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { useGetApi } from "src/hooks";
import { PageContainer } from "src/styled";

import { type ISubscription } from "./Subscriptions.types";

const mapSubscriptions = (data: any) => {
  let list: ISubscription[] = [];
  if (data?.data?.content?.list) {
    list = data.data.content.list.map((el: ISubscription) => ({
      ...el,
      start: dayjs(el.start).format("D MMM YYYY"),
      end: dayjs(el.end).format("D MMM YYYY"),
      active: el.active ? "Yes" : "No",
    }));
  }
  return { ...data?.data?.content, list };
};

const Subscriptions = () => {
  const { data, isLoading } = useGetApi({
    request: "get-management",
    body: { _sect: "_subscriptions" },
    mapper: mapSubscriptions,
  });
  return (
    <PageContainer>
      <Breadcrumbs border={false} />
      <ManagementTable
        section="_subscriptions"
        data={data?.list ?? []}
        loading={isLoading}
      />
    </PageContainer>
  );
};

export default Subscriptions;
